import type { ModuleConfig } from "../moduleConfig.types";

export const reportsModuleConfig: ModuleConfig = {
  // ── Module-level base config ──────────────────────────────────────────────
  config: {
    type: "MODULE",
    // Required: views still mounted during a module switch compare this with
    // `userSelection.module` to tell the switch is in progress. Left empty, they
    // read it as a cold start and dispatch module-less corrections that bounce
    // the user back to the module they left (e.g. Profile → Reports).
    module: "REPORTS",
    supportMarkets: false,
    supportBrands: false,
    supportSecondaryBrands: false,
    supportMode: false,
    supportBase: false,
    supportDatePeriod: false,
    supportVisualisationSwitch: false,
    supportedURLKeys: [],
  },
};
